module.exports = __webpack_public_path__ + "static/img/frackIcon3.a378a2da.png";